<script lang="ts">
	let className = '';
	export { className as class };
</script>

<footer
	class={`bg-gray-1 text-gray-11 px-3 lg:px-6 items-center text-light pt-6 pb-9 sm:pb-12 ${className}`}
>
	<div class="w-full max-w-[81rem] xxl:max-w-[93rem] mx-auto text-[0.9375rem] leading-[1.125rem]">
		<img
			src="/icons/t-logo-claim.svg"
			alt="Telekom - Erleben, was verbindet."
			class="w-[8.125rem] h-9.5"
			loading="lazy"
		/>
		<div class="flex flex-col mt-9 sm:mt-6 xxl:flex-row xxl:justify-between">
			<a
				target="_blank"
				rel="noopener noreferrer"
				href="https://www.telekom.de/ueber-das-unternehmen"
				class="mr-6 hover:underline
">© Telekom Deutschland GmbH</a
			>
			<ul class="flex flex-wrap mt-0.5 flex-col md:flex-row leading-5.25">
				<li>
					<a
						rel="noopener noreferrer"
						target="_blank"
						href="https://www.telekom.de/impressum"
						class="mr-6 hover:underline block lg:inline-block">Impressum</a
					>
				</li>
				<li>
					<a
						target="_blank"
						rel="noopener noreferrer"
						href="http://www.telekom.de/agb"
						class="mr-6 hover:underline block lg:inline-block">AGB</a
					>
				</li>
				<li>
					<a
						target="_blank"
						rel="noopener noreferrer"
						href="https://telekom.de/produktinformationsblatt"
						class="mr-6 hover:underline block lg:inline-block">Produktinformationsblatt</a
					>
				</li>
				<li>
					<a
						target="_blank"
						rel="noopener noreferrer"
						href="https://www.telekom.de/ueber-das-unternehmen/verbraucherinformationen"
						class="mr-6 hover:underline block lg:inline-block">Verbraucherinformationen</a
					>
				</li>
				<li>
					<a
						target="_blank"
						rel="noopener noreferrer"
						href="https://www.telekom.de/ueber-das-unternehmen/jugendschutz"
						class="mr-6 hover:underline block lg:inline-block">Jugendschutz</a
					>
				</li>
				<li>
					<a
						rel="noopener noreferrer"
						target="_blank"
						href="https://telekom.de/ueber-das-unternehmen/datenschutz#fragen-und-antworten"
						class="mr-6 hover:underline block lg:inline-block">Datenschutz</a
					>
				</li>
			</ul>
		</div>
	</div>
</footer>
